<template>
  <div class="c-calendar-month" id="c-calendar">
    <div class="d-flex align-center mb-1">
      <v-toolbar-title class="w-28">{{monthText}}</v-toolbar-title>
      <v-btn icon :disabled="month === minMonth" @click="goMonth(-1)">
        <v-icon>chevron_left</v-icon>
      </v-btn>
      <v-btn icon :disabled="month === maxMonth" @click="goMonth(1)">
        <v-icon>chevron_right</v-icon>
      </v-btn>
    </div>

    <v-calendar
      type="month"
      locale="jp-ja"
      now="2021-04-12"
      :value="month"
    >
      <!-- #day-label は使用しない -->
      <template #day-label>
        <div/>
      </template>

      <template #day="{date, day}">
        <c-cell
          :day="day"
          :date="calendar[date]"
          :state="states[date]"
          :anytime="anytime"
          :startDate="startDate"
          :returnDate="returnDate"
          :span="span"
          :spanText="spanText"
          @selected="book"
          @child_selectDate="child_selectDate"
        />
      </template>
    </v-calendar>
  </div>
</template>

<style lang="scss">
/*
 * 曜日
 */
.c-calendar-month {
  .v-calendar-weekly__head .v-calendar-weekly__head-weekday {
    padding: .25rem;
    background-color: var(--v-cal-week-base) !important;
    color: #FFFFFF !important;
    font-weight: bold;

    &:nth-child(1) {
      background-color: var(--v-cal-holiday-base) !important;
    }
    &:nth-child(7) {
      background-color: var(--v-cal-saturday-base) !important;
    }
  }

  .v-calendar-weekly__day-label {
    display: none;
  }

  .v-calendar-weekly__day.v-outside {
    .c-cell {
      visibility: hidden;
    }
  }
}
</style>

<script>
import CCell from './CCell'

import * as time from '@/libs/time'

export default {
  name: 'CCalendarMonth',
  components: {
    CCell
  },

  props: {
    stationID: {
      type: Number,
      required: true
    },
    car: {
      type: Object,
      required: true
    },
    dates: {
      type: Array,
      required: true
    },
    calendar: {
      type: Object,
      required: true
    },
    states: {
      type: Object,
      required: true
    },
    startDate: Object,
    returnDate: Object,
    span: Object,
    spanText: String
  },

  data: () => ({
    month: ''
  }),

  computed: {
    anytime () {
      let result = 0
      if (this.car.attributes.vkey === 1 || this.car.attributes.keykey) {
        result = 1
      }
      return result
    },

    hasDates () {
      return this.dates && this.dates.length > 0
    },

    minMonth () {
      if (!this.hasDates) {
        return time.format('Y-m-01', new Date())
      }
      return time.format('Y-m-01', this.dates[0])
    },

    maxMonth () {
      if (!this.hasDates) {
        return this.minMonth
      }
      return time.format('Y-m-01', this.dates[this.dates.length - 1])
    },

    monthText () {
      return time.format('Y年n月', this.month)
    }
  },

  created () {
    this.month = this.minMonth
  },

  methods: {
    child_selectDate (date) {
      this.$emit('parent_selectDate', date)
    },

    goMonth (delta) {
      const month = time.create(this.month)
      month.setMonth(month.getMonth() + delta)
      this.month = time.format('Y-m-01', month)
    }
  }
}
</script>
